"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } /** When your routing table is too long, you can split it into small modules **/
var maintainRouter = {
  path: '/maintain',
  component: _layout.default,
  redirect: '/maintain/picture',
  name: 'maintain',
  meta: {
    title: '维护',
    icon: 'clipboard'
  },
  children: [{
    path: 'user/:type?',
    name: 'MaintainUser',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/maintain/user'));
      });
    },
    meta: {
      title: '个人中心',
      icon: 'clipboard'
    },
    hidden: true
  }, {
    path: 'picture',
    name: 'picture',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/maintain/picture'));
      });
    },
    meta: {
      title: '素材管理',
      icon: 'clipboard'
    },
    hidden: false
  }, {
    path: 'logistics',
    name: 'Logistics',
    alwaysShow: true,
    redirect: '/logistics/cityList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/maintain'));
      });
    },
    meta: {
      title: '物流管理',
      icon: 'clipboard',
      roles: ['admin']
    },
    children: [{
      path: 'companyList',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/maintain/logistics/companyList'));
        });
      },
      name: 'companyList',
      meta: {
        title: '物流公司',
        icon: ''
      }
    }]
  }, {
    path: 'sensitiveLog',
    name: 'sensitiveLog',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/maintain/sensitiveList'));
      });
    },
    meta: {
      title: '敏感操作日志',
      icon: 'clipboard'
    },
    hidden: false
  }, {
    path: 'orderLog',
    name: 'OrderLog',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/maintain/orderLog'));
      });
    },
    meta: {
      title: '订单日志',
      icon: 'clipboard'
    },
    hidden: false
  }, {
    path: 'operationLog',
    name: 'OperationLog',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/maintain/operationLog'));
      });
    },
    meta: {
      title: '全局操作日志',
      icon: 'clipboard'
    },
    hidden: false
  }, {
    path: 'systemForm',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/maintain/systemForm'));
      });
    },
    name: 'systemForm',
    meta: {
      title: '系统表单',
      noCache: true
    }
  }]
};
var _default = exports.default = maintainRouter;